module.exports = __webpack_public_path__ + "img/chess_chinesechessblack6.51e1e98b.png";